import React from 'react'
// @ts-ignore
import MathJax from 'react-mathjax2'
import {isDesktop} from 'react-device-detect'
import Question from '../../../common/model/Question'
import QuestionInstance from '../../../common/model/QuestionInstance'
import {MCQ} from '../../../common/model/QuestionContent'
import ThemeConstants from '../../../common/data/styles/ThemeConstants'
import {Alignment, Button} from '@blueprintjs/core'

interface Props {
    question: Question
    questionInstance: QuestionInstance
    selectAnswer: (answer: string) => void
}

const imageSrc = ''

const formatText = (fullText: string) => {
    try {
        return fullText.split('<br>').map((text: string) => (
            <MathJax.Context>
                <MathJax.Text text={text} />
            </MathJax.Context>
        ))
    } catch (e) {}
}

export default function MCQRenderer(props: Props) {
    const styles = isDesktop ? stylesDesktop : stylesMobile

    const selectAnswer = (index: number) => {
        props.selectAnswer((props.question.content as MCQ).choices[index].toString())
    }
    const choices: string[] = (props.question.content as MCQ).choices
    const shuffledChoices: string[] = choices

    return (
        <div style={styles.container}>
            <div>
                <div style={styles.question}>
                    <span>{formatText((props.question.content as MCQ).question)}</span>
                </div>
                <div style={styles.choices}>
                    {choices.map((choice: string, index: number) => (
                        <div
                            onClick={() => {
                                selectAnswer(index)
                            }}
                            style={
                                props.questionInstance.selectedAnswer.toString() === shuffledChoices[index].toString()
                                    ? styles.selectedChoiceContainer
                                    : styles.choiceContainer
                            }>
                            {choice.search && choice.search('golden-eye-marquis-') > -1 ? (
                                <img
                                    onClick={() => {
                                        selectAnswer(index)
                                    }}
                                    src={imageSrc + choice.replace('golden-eye-marquis-', '')}
                                    alt={`Choice #${index}`}
                                />
                            ) : (
                                <Button
                                    onClick={() => {
                                        selectAnswer(index)
                                    }}
                                    minimal={props.questionInstance.selectedAnswer.toString() !== shuffledChoices[index].toString()}
                                    outlined={props.questionInstance.selectedAnswer.toString() === shuffledChoices[index].toString()}
                                    style={styles.choice}
                                    text={formatText(choice.toString())}
                                    alignText={Alignment.LEFT}
                                    icon={
                                        props.questionInstance.selectedAnswer.toString() === shuffledChoices[index].toString()
                                            ? 'tick-circle'
                                            : 'circle'
                                    }
                                />
                            )}
                        </div>
                    ))}
                </div>
            </div>
            {(props.question.content as MCQ).supportImage &&
            (props.question.content as MCQ).supportImage.length &&
            isDesktop ? (
                <div style={styles.supportImage}>
                    <img
                        style={styles.image}
                        src={imageSrc + (props.question.content as MCQ).supportImage}
                        alt={'Support Image'}
                    />
                </div>
            ) : (
                <div />
            )}
        </div>
    )
}

const stylesDesktop = {
    question: {
        fontSize: '1.3em',
        fontFamily: 'Bamini',
        marginBottom: '2em',
    },
    image: {width: '100%'},
    choice: {
        fontSize: '1.3em',
        fontFamily: ThemeConstants.headingFont,
        width: '100%',
    },
    container: {
        padding: '3vw',
        paddingTop: '3vw',
        paddingBottom: '2vw ',
        display: 'flex',
        flexDirection: 'row' as 'row',
        justifyContent: 'space-between',
    },
    choiceContainer: {
        backgroundColor: ThemeConstants.primaryColorLight,
        marginTop: '1vw',
        display: 'flex',
        flexDirection: 'row' as 'row',
        alignItems: 'center',
    },
    selectedChoiceContainer: {
        backgroundColor: ThemeConstants.primaryColorLight,
        marginTop: '1vw',
        display: 'flex',
        flexDirection: 'row' as 'row',
        alignItems: 'center',
    },
    choices: {
        width: 'fit-content',
    },
    choiceButton: {
        height: '1.5vw',
        width: '1.5vw',
        marginRight: '0.6vw',
    },
    supportImage: {
        backgroundColor: ThemeConstants.primaryColorLight,
        padding: '1vw',
        marginLeft: '1.5vw',
        borderRadius: 5,
        maxWidth: '25%',
        height: 'fit-content',
        display: 'flex',
        flexDirection: 'column' as 'column',
    },
    supportImageHeading: {
        color: 'white',
        fontSize: '1.5vw',
        marginBottom: '0.6vw',
        alignSelf: 'center',
    },
}

const stylesMobile = {
    image: {},
    question: {
        fontSize: '2.5vh',
        marginBottom: '3vh',
    },
    choice: {
        fontSize: '2.5vh',
        textAlign: 'left' as 'left',
    },
    container: {
        padding: '4.5vw',
        paddingTop: '3vh',
        paddingBottom: '2vh',
        display: 'flex',
        flexDirection: 'row' as 'row',
        justifyContent: 'space-between',
    },
    choiceContainer: {
        // backgroundColor: '#4f5259',
        paddingTop: '1vh',
        paddingBottom: '1vh',
        paddingLeft: '2vh',
        paddingRight: '2vh',
        marginTop: '3vh',
        borderRadius: '1vh',
        display: 'flex',
        flexDirection: 'row' as 'row',
        alignItems: 'center',
    },
    selectedChoiceContainer: {
        // backgroundColor: '#374249',
        paddingTop: '1vh',
        paddingBottom: '1vh',
        paddingLeft: '2vh',
        paddingRight: '2vh',
        marginTop: '3vh',
        borderRadius: '1vh',
        display: 'flex',
        flexDirection: 'row' as 'row',
        alignItems: 'center',
        // border: '0.8vh solid #7f8289',
    },
    choices: {
        width: 'fit-content',
    },
    choiceButton: {
        height: '3vh',
        width: '3vh',
        marginRight: '1vh',
    },
    supportImage: {
        width: '25%',
        backgroundColor: '#4f5259',
        padding: '1vw',
        borderRadius: '1vh',
        height: 'fit-content',
        display: 'flex',
        flexDirection: 'column' as 'column',
    },
}
